import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAboutAdmin, updateAbout } from "../../actions/aboutActions";
import { ABOUT_UPDATE_RESET } from "../../constants/aboutConstants";
import Uploader from "../../components/images/Uploader";

const AdminAboutScreen = () => {
  const dispatch = useDispatch();

  const aboutAdminDetails = useSelector((state) => state.aboutAdminDetails);
  const { loading, error, about } = aboutAdminDetails;

  const aboutUpdateState = useSelector((state) => state.aboutUpdate);
  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success: successUpdate,
  } = aboutUpdateState;

  const [title, setTitle] = useState("");
  const [leftText, setLeftText] = useState("");
  const [rightText, setRightText] = useState("");
  const [images, setImages] = useState([]);

  useEffect(() => {
    dispatch(getAboutAdmin());
  }, [dispatch]);

  useEffect(() => {
    if (about) {
      setTitle(about.title || "");
      setLeftText(about.leftText || "");
      setRightText(about.rightText || "");
      setImages(Array.isArray(about.images) ? about.images : []);
    }
  }, [about]);

  useEffect(() => {
    if (successUpdate) {
      const timer = setTimeout(() => {
        dispatch({ type: ABOUT_UPDATE_RESET });
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [dispatch, successUpdate]);

  const submitHandler = (e) => {
    e.preventDefault();

    dispatch(
      updateAbout({
        title,
        leftText,
        rightText,
        images,
      }),
    );
  };

  return (
    <div className="container py-4" style={{ maxWidth: "980px" }}>
      <h2 className="mb-4">Edit About Page</h2>

      {loadingUpdate && <p>Saving...</p>}
      {errorUpdate && <p className="text-danger">{errorUpdate}</p>}
      {successUpdate && <p className="text-success">Updated successfully</p>}

      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="text-danger">{error}</p>
      ) : (
        <form onSubmit={submitHandler}>
          <div className="mb-3">
            <label className="form-label">Page Title</label>
            <input
              type="text"
              className="form-control"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Left Column Text</label>
            <textarea
              rows="8"
              className="form-control"
              value={leftText}
              onChange={(e) => setLeftText(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Right Column Text</label>
            <textarea
              rows="8"
              className="form-control"
              value={rightText}
              onChange={(e) => setRightText(e.target.value)}
            />
          </div>

          <div className="mb-4">
            <label className="form-label">About Image</label>
            <Uploader
              existingImages={images}
              setImageUrls={setImages}
              folder="about"
            />
          </div>

          <button type="submit" className="btn btn-dark">
            Save Changes
          </button>
        </form>
      )}
    </div>
  );
};

export default AdminAboutScreen;
